<template>
  <div data-cy="bankStrip" class="wrapper" :class="{ creditFormBankStripPadding: creditForm }">
    <div class="icon" v-for="company in banksRendered" :class="`mr-${logoSpacing}`" :key="company">
      <img
        :src="require(`../assets/bank-logos/${company}-logo.png`)"
        :alt="getBankList[company]"
        width="38"
        height="38"
      />
    </div>
    <div
      class="more-sign mt-2 small"
      :class="{ 'd-none': creditForm }"
      v-if="banksRendered.length"
      v-html-safe="$t('message.common.andMore')"
    ></div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'BankStrip',
  data() {
    return {};
  },
  props: {
    logoSpacing: {
      type: [String, Number],
      required: false,
      default: '1',
    },
    companyList: {
      type: Array,
      required: true,
    },
    creditForm: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters('business', ['getBankList']),
    banksRendered() {
      // return first five banks from the list
      return this.companyList.slice(0, 4);
    },
  },
};
</script>
<style scoped lang="scss">
.wrapper {
  position: relative;
  display: inline-block;

  .icon {
    display: inline-block;
  }
  &::before {
    content: '';
    width: 0;
    height: 100%;
  }
  justify-content: flex-start;
  @media (min-width: 576px) {
    justify-content: flex-end;
  }
}
.small {
  display: inline-block;
  vertical-align: middle;
  color: #6d7783;
  font-size: 12px;
  font-weight: normal;
}
.creditFormBankStripPadding {
  padding: 16px;
}
</style>
